import * as React from "react";
function SvgToneNegative(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path d="M32 16A16 16 0 1116 0a16 16 0 0116 16zm-22-5a2 2 0 102 2 2 2 0 00-2-2zm12 0a2 2 0 102 2 2 2 0 00-2-2zm.8 12.6a1 1 0 00-.2-1.4c-4.38-3.29-8.82-3.29-13.2 0a1 1 0 101.2 1.6c3.63-2.72 7.17-2.72 10.8 0a1 1 0 001.4-.2z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgToneNegative);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
